import { render, staticRenderFns } from "./Feriados.vue?vue&type=template&id=2293bfd1&scoped=true&"
import script from "./Feriados.vue?vue&type=script&lang=js&"
export * from "./Feriados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293bfd1",
  null
  
)

export default component.exports